import React from 'react'
import { Link, useParams, useLocation, useRouteMatch } from 'react-router-dom'
import AspectRatio from 'components/AspectRatio'
import ConditionalWrap from 'components/ConditionalWrap'
import Path from 'components/Path'
import classNames from 'classnames'

const Plots = ({ afangar }) => {
  const { afangi } = useParams()
  const { url } = useRouteMatch()
  const location = useLocation()

  const { title, takkamynd } = React.useMemo(() => {
    return afangar ? afangar.find((i) => i.key === afangi) : null
  }, [afangar, afangi])

  return (
    <AspectRatio ratio={takkamynd.image.height / takkamynd.image.width}>
      <img src={takkamynd.image.src} alt={title} />

      <svg
        viewBox={`0 0 ${takkamynd.image.width} ${takkamynd.image.height}`}
        style={{
          vectorEffect: 'non-scaling-stroke',
        }}
      >
        {afangi === 'aedaroddi-40-49' ? (
          <g>
            <text
              transform="matrix(.6911 -.7228 .7228 .6911 175.9757 1703.0448)"
              fontSize="32pt"
              fill="#fff"
            >
              Æðaroddi 41
            </text>
            <text
              transform="matrix(.6911 -.7228 .7228 .6911 422.9388 1443.3553)"
              fontSize="32pt"
              fill="#fff"
            >
              Æðaroddi 43
            </text>
            <text
              transform="matrix(.6911 -.7228 .7228 .6911 668.9085 1175.4603)"
              fontSize="32pt"
              fill="#fff"
            >
              Æðaroddi 45
            </text>
            <text
              transform="matrix(.6911 -.7228 .7228 .6911 921.7923 909.7402)"
              fontSize="32pt"
              fill="#fff"
            >
              Æðaroddi 47
            </text>
            <text
              transform="matrix(.9654 -.2606 .2606 .9654 1561.0079 150.937)"
              fontSize="32pt"
              fill="#fff"
            >
              Æðaroddi 49
            </text>
            <text
              transform="matrix(.6911 -.7228 .7228 .6911 668.9085 1175.4603)"
              fontSize="32pt"
              fill="#fff"
            >
              Æðaroddi 45
            </text>
            <text
              transform="matrix(.6911 -.7228 .7228 .6911 921.7923 909.7402)"
              fontSize="32pt"
              fill="#fff"
            >
              Æðaroddi 47
            </text>
            <text
              transform="matrix(.6911 -.7228 .7228 .6911 1078.9452 1593.8939)"
              fontSize="32pt"
              fill="#fff"
            >
              Æðaroddi 42
            </text>
            <text
              transform="matrix(.6911 -.7228 .7228 .6911 1331.829 1328.1747)"
              fontSize="32pt"
              fill="#fff"
            >
              Æðaroddi 44
            </text>
          </g>
        ) : null}
        {takkamynd.list.map((item) => {
          const fullpath = `${url}/${item.lod}`
          const fill = item?.seld ? 'text-danger' : 'text-secondary'
          const additionalProps = {}

          if (afangi === 'aedaroddi-40-49') {
            additionalProps.stroke = '#fff'
            additionalProps.strokeWidth = '5px'
          }

          // live condition: item.i_auglysingu
          return (
            <ConditionalWrap
              key={item.lod}
              condition={item.i_auglysingu || item.i_birtingu}
              wrap={(children) => <Link to={fullpath}>{children}</Link>}
            >
              <Path
                className={classNames(item.i_auglysingu ? fill : 'text-white', {
                  'text-dark': item.i_birtingu && !item.i_auglysingu,
                })}
                opacity={0.35}
                d={item.d}
                isActive={fullpath === location.pathname}
                {...additionalProps}
              />
            </ConditionalWrap>
          )
        })}
      </svg>
    </AspectRatio>
  )
}

export default React.memo(Plots)
